import { cn } from '../../../../utils/global';

const PricingCard = ({ data, featured = false, cardIndex, currentGroup }) => {
	const getValue = () => {
		return data.value;
	};

	const getSubtitle = () => {
		if (cardIndex === 0) return 'ACCESS FREE FEATURES NOW';
		if (cardIndex === 1) return 'GET STARTED TODAY';
		if (cardIndex === 2) return 'CUSTOM PLANS STARTING FROM';
		return '';
	};

	const getPriceSubtext = () => {
		if (currentGroup === 'salesIncentive' && (cardIndex === 1 || cardIndex === 2)) {
			return 'Of verified sales';
		} else if (cardIndex === 0) {
			return '00';
		} else {
			return 'Per Active Door / Month';
		}
	};

	const getSecondaryButtonText = () => {
		if (cardIndex === 0) return 'Sign Up Free Now';
		if (cardIndex === 1) return 'Create Your Free Account';
		if (cardIndex === 2) return 'Talk To Sales';
		return '';
	};

	const isMiddleCard = cardIndex === 1;

	const renderValue = () => {
		if (data.value === '') {
			return (
				<span
					className={`text-5xl font-bold mx-1 invisible ${
						isMiddleCard ? 'text-[#fff]' : 'text-[#343640]'
					}`}
				>
					00
				</span>
			);
		}

		if (currentGroup === 'salesIncentive') {
			return (
				<>
					<span
						className={`text-5xl font-bold mx-1 ${isMiddleCard ? 'text-[#fff]' : 'text-[#343640]'}`}
					>
						{getValue()}
					</span>
				</>
			);
		} else {
			return (
				<>
					<span
						className={`text-5xl font-bold mx-1 ${isMiddleCard ? 'text-[#fff]' : 'text-[#343640]'}`}
					>
						{getValue()}
					</span>
				</>
			);
		}
	};

	return (
		<div
			className={`w-full rounded-xl ${
				isMiddleCard
					? 'bg-[#7559c1] border-2 border-[#7559c1] md:transform md:scale-y-[1.06] md:scale-x-95'
					: 'bg-[#fbfafc] border border-[#deeaf1]'
			}`}
		>
			<div
				className={`p-6 ${isMiddleCard ? 'md:pt-8 md:pb-7' : ''} border-b ${
					featured ? 'border-[#ff7a00]' : 'border-[#deeaf1]'
				} flex flex-col items-center justify-center`}
			>
				<h3
					className={`text-3xl font-bold text-center mt-6 ${
						isMiddleCard ? 'text-[#fff]' : 'text-[#343640]'
					}`}
				>
					{data.title}
				</h3>
			</div>

			<div className="p-6">
				<h4
					className={`text-sm font-bold text-center ${
						isMiddleCard ? 'text-[#fff]' : 'text-[#000]'
					} -mt-2`}
				>
					{getSubtitle()}
				</h4>
				<div className="flex flex-col items-center mb-6">
					<div className="flex items-end justify-center mt-6 mb-6">{renderValue()}</div>
					<p
						className={`text-lg font-bold mt-1 ${isMiddleCard ? 'text-[#fff]' : 'text-[#000]'} ${
							cardIndex === 0 ? 'invisible' : ''
						}`}
					>
						{getPriceSubtext()}
					</p>
				</div>

				<button
					className={`text-sm py-4 mb-6 rounded-3xl mx-auto block bg-[#ff7a00] text-white ${
						isMiddleCard ? 'w-3/4' : 'w-3/5'
					}`}
				>
					{getSecondaryButtonText()}
				</button>

				<div className="mb-6">
					<p className={`font-bold mb-5 mt-4 ${isMiddleCard ? 'text-[#fff]' : 'text-[#4a4a4a]'}`}>
						{cardIndex === 0
							? 'ACCESS, FOR FREE:'
							: cardIndex === 1
							? 'EVERYTHING IN FREE, PLUS:'
							: 'EVERYTHING IN PAYG, PLUS:'}
					</p>
					{data.includes.map((item, index) => (
						<div
							key={index}
							className={cn(
								'flex items-center mb-2',
								index === data.includes.length - 1 ? 'mb-0' : ''
							)}
						>
							<img
								src={
									isMiddleCard
										? 'https://plugin.markaimg.com/public/c9ce20ab/dMpHoLRapexebOwSjbPo1G3qvvI4pB.png'
										: 'https://plugin.markaimg.com/public/c9ce20ab/jscl51ZkoG8VFzS5ikEmzQ8KNmXQTC.png'
								}
								alt=""
								className="w-4 h-4 mr-2"
							/>
							<p className={`text-sm ${isMiddleCard ? 'text-[#fff]' : 'text-[#000]'}`}>{item}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default PricingCard;
